<div class="row" style="margin-top:65px">
  <div class="col-12">
    <!-- Drive Browser -->
    <div class="drive-browser">
      <h4 class="mb-3"><i class="fas fa-fw fa-hard-drive me-2"></i>File Storage</h4>
      <div class="card bg_light">
        <div class="card-body p-2">
          <div class="drive-controls d-flex flex-row">
            <button class="btn btn-sm btn-dark me-2" (click)="openMyDrive()" style="width:150px">
              <i class="fas fa-fw fa-folder me-2"></i>My Drive
            </button>

            <select class="form-select form-select-sm" (change)="onDriveSelect($event)" [value]="selectedDriveId" style="width:300px">
              <option value="">-- Select Shared Drive --</option>
              <option *ngFor="let d of drives" [value]="d.id">{{ d.name }}</option>
            </select>
          </div>
        </div>
      </div>

      <!-- Breadcrumbs -->
      <div class="breadcrumbs my-2 py-2 border-bottom" *ngIf="breadcrumbs && breadcrumbs.length">
        <ng-container *ngFor="let crumb of breadcrumbs; let i = index" style="border:solid 1px">
          <a *ngIf="i < breadcrumbs.length - 1" href="javascript:void(0)" (click)="goToBreadcrumb(i)"><i class="fas fa-fw fa-folder c_sand me-1"></i>{{ crumb.name }}</a>
          <span *ngIf="i === breadcrumbs.length - 1" style="font-weight:600 !important">
            <i class="fas fa-fw fa-folder c_sand me-1"></i>{{ crumb.name }}
            <span class="ms-3 c_bonedk" *ngIf="selection!.folderId != 'root'">{{ selection!.folderId || '(none)' }}</span>
          </span>
          <span *ngIf="i < breadcrumbs.length - 1" class="mx-2">/</span>
        </ng-container>
      </div>

      <!-- Loading Indicator -->
      <div *ngIf="loading">Loading...</div>

      <!-- Current View Listing -->
      <div class="items">
        <div class="row">
          <div class="col-12 col-md-6 col-lg-8">
            <div *ngIf="folders.length > 0">
              <div class="item mb-1 pointer"
                   *ngFor="let item of folders"
                   (dblclick)="openFolder(item)">
                <span><i class="fas fa-fw fa-folder mx-2 c_sand"></i></span>
                <span class="c_black">{{ item.name }}</span>
              </div>
            </div>
            <div *ngIf="items.length > 0">
              <div class="item mb-1 c_black pointer"
                   *ngFor="let item of items"
                   (dblclick)="onFileDoubleClick(item)">
                <span><i class="far fa-fw fa-file mx-2"></i></span>
                <span>{{ item.name }}</span>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-6 col-lg-4">
            <div class="mb-3" *ngIf="selection">
              <button class="btn btn-sm btn-dark me-1" (click)="newFolder()" [disabled]="!selection.folderId">
                <i class="far fa-fw fa-folder me-1"></i>
                Create Folder
              </button>
              <button class="btn btn-sm btn-dark me-1" (click)="uploadFilesToDrive()" [disabled]="!selection.folderId">
                <i class="fas fa-fw fa-upload me-1"></i>
                Upload Files
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="googleDriveModal" tabindex="-1" aria-labelledby="googleDriveModal" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable">
    <div class="modal-content shadow-lg">
      <div class="modal-header bg-dark">
        <h5 class="modal-title c_black" id="composeModalLabel"><i class="fas fa-fw fa-{{editorIcon}} me-2"></i>File Storage - {{editorMode}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body" style="height:33vh">
        <div class="row">
          <div class="col-12">
            <div class="text-center c_{{errorMsgColor}} bolder" *ngIf="errorMsg != ''">
              <i class="fas fa-fw fa-exclamation-triangle me-2"></i>{{errorMsg}}
            </div>
          </div>
        </div>
        <div class="row" *ngIf="editorMode.indexOf('Create') > -1">
          <div class="col-12">
            <div class="py-3">
              <input id="new_folder_name" type="text" class="form-control form-control-sm" placeholder="Enter Folder Name" [(ngModel)]="newFolderName" />
            </div>
          </div>
        </div>
        <div class="row" *ngIf="editorMode.indexOf('Upload') > -1">
          <div class="col-12">
            <div class="py-3">
              <input class="form-control form-control-sm" type="file" id="up_file"
                     [(ngModel)]="uploadFiles"
                     (change)="populateList($event)"
                     multiple
                     accept=".jpg, .jpeg, image/png, application/pdf" />
              <div id="upload_list" [innerHTML]="uploadDetail" class="my-2" *ngIf="uploadDetail != ''"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer bg-light text-end p-2">
        <button type="button" class="btn btn-sm btn-outline-dark" data-bs-dismiss="modal">
          <i class="fas fa-fw fa-times me-2"></i>Cancel
        </button>
        <button type="button" class="btn btn-sm btn-dark" (click)="createFolder()">
          <i class="fas fa-fw fa-save me-2"></i>Save
        </button>
      </div>
    </div>
  </div>
</div>
